import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {Headline} from '../../services/markdown-parser.service';

@Component({
  selector: 'cc-table-of-contents',
  templateUrl: './table-of-contents.component.html',
  styleUrls: ['./table-of-contents.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableOfContentsComponent {
  @Input() headlines: Headline[];
  @Input() maxDepth = Infinity;
  @Input() activeAnchor: string;

  readonly anchorPrefix = window.location.pathname;
}
